/**
 * Binds click events to modal launcher buttons/links and modal close buttons
 * - expects <sometag data-target-modal-id="{modal-id}"> to open the dialog
 * - expects <sometag class="btn-close"> to bind the dialog close event to
 */
class VideoModals {
  public constructor() {
    const elModalOpeners = [...document.querySelectorAll('[data-target-modal-id]')].filter(modal => modal instanceof HTMLElement || modal instanceof SVGElement);

    for (const elModalOpener of elModalOpeners) {
      const modalId = elModalOpener.dataset['targetModalId'];
      if (modalId === undefined) {
        continue;
      }
      const elModal = document.getElementById(modalId);
      if (!elModal || !(elModal instanceof HTMLDialogElement)) {
        continue;
      }

      elModalOpener.addEventListener('click', (ev: Event) => {
        ev.preventDefault(); // prevent URL change if launched from a link
        elModal.showModal();
      });

      const elModalCloseButton = elModal.querySelector('.btn-close');
      elModalCloseButton?.addEventListener('click', () => {
        elModal.close();
      });
    }
  }
}

document.readyState === 'loading'
  ? document.addEventListener('DOMContentLoaded', () => new VideoModals())
  : new VideoModals();
